import alreadyVisitedPointsUpdated from "./alreadyVisitedPointsUpdatedListener";
import detailsUpdated from "./detailsUpdatedListener";
import loadingAnnotation from "./loadingAnnotationListener";
import loadingPrint from "./loadingPrintListener";
import remainingPrints from "./remainingPrintsListener";
import reportPrinted from "./reportPrintedListener";

export const alreadyVisitedPointsUpdatedListener = alreadyVisitedPointsUpdated;
export const detailsUpdatedListener = detailsUpdated;
export const loadingAnnotationListener = loadingAnnotation;
export const loadingPrintListener = loadingPrint;
export const remainingPrintsListener = remainingPrints;
export const reportPrintedListener = reportPrinted;
